"use client";
import { motion } from "framer-motion";
import ProjectCard from "../components/ProjectCard";

// Define the animation variants for the curtain
const curtainVariants = {
  hidden: {
    height: 0,
    y: "-0.4rem", // start shifted upward
    opacity: 1,
  },
  visible: {
    height: "calc(100% - 0.8rem)", // fills the space between the 1rem padding (top and bottom)
    width: "calc(100% - 0.8rem)", // fills the space between the 1rem padding (left and right)
    y: "0",
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
};

export default function Cert() {
  return (
    <>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="Blockchain Developer Training Certificate"
          published="2022-03-06"
          href="https://drive.google.com/file/d/1enEU0HZT-eDr_3ig3DJJlIZhkTr9bDEO/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="Codechef - CODE'WALK Appreciation Certificate"
          published="2022-01-23"
          href="https://drive.google.com/file/d/1QTZgqll8FHfJr5mDINHwV1XJKj39Ud0g/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="Google Cloud - 30 Days of Cloud Program"
          published="2021-12-04"
          href="https://drive.google.com/file/d/1vLGmfX1rVDV2sDeXIX4ZBHrZOIv9x9-V/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="Edureka - Full Stack Web Development Session"
          published="2021-08-13"
          href="https://drive.google.com/file/d/1alOgdQ1dWmEDqyv0BQN1C_GQB4yRQCkw/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="Microsoft - AI for Students Workshop"
          published="2021-12-24"
          href="https://drive.google.com/file/d/1b5ztdWoBtS-JMMB6yNvcc0Xu_ZOprFXI/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="IBM Skillsbuild - Cyber-Security"
          published="2021-09-18"
          href="https://drive.google.com/file/d/1OCBJklOf2rMX_pAMk3H8QqwIE6NM42r_/view?usp=sharing"
        />
      </motion.div>
      <motion.div
        className="relative border border-stone-800/90 py-[0.4rem] px-[1rem] rounded-lg overflow-hidden mb-4"
        initial="hidden"
        whileHover="visible"
      >
        {/* Animated curtain element */}
        <motion.div
          className="absolute top-0 left-0 w-full rounded-md bg-stone-800/80"
          style={{ left: "0.4rem", right: "0.4rem", top: "0.4rem" }}
          variants={curtainVariants}
        />

        {/* Card content remains above the curtain */}
        <ProjectCard
          title="IBM Skillsbuild - Cyber-Security Basics"
          published="2022-01-22"
          href="https://drive.google.com/file/d/1pKICAD7Xg6NybXYWMfVbwQPuz9hpFpbS/view?usp=sharing"
        />
      </motion.div>
    </>
  );
}
